//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import panel from "./panel";
import ImgBox from "./panel-imgbox";
export default {
  components: {
    panel: panel,
    ImgBox: ImgBox
  }
};